import SEO from '../components/SEO/SEO'
import ButtonLink from '../components/ButtonLink/ButtonLink'
import ContactForm from '../components/ContactForm/ContactForm'
import CompareTable from '../components/Table/CompareTable'
import Layout from '../layout/Layout'

import classes from '../styles/section.module.css'

const HowWeCompare = () => {
  return (
    <>
      <SEO />
      <Layout>
        <div className="relative">
          <div className="absolute inset-x-0 bottom-0 bg-gray-100 h-1/2" />
          <div className="mx-auto">
            <div className="relative">
              <div className="absolute inset-0">
                <img
                  className="object-cover w-full h-full"
                  src="peoplecollaborating.png"
                  alt="People working on laptop together"
                />
              </div>
              <div className="relative max-w-screen-xl px-4 py-16 mx-auto md:py-16 lg:py-32">
                <h1 className="text-3xl tracking-tight md:text-5xl">
                  <span className="block text-blue-dark">
                    We created the health insurance
                  </span>
                  <span className="block text-globeGreen">
                    that we’ve always wanted to have.
                  </span>
                </h1>
                <p className="max-w-lg mt-6 text-xl text-grey sm:max-w-3xl">
                  Better health insurance for everyone by putting people first.
                </p>
                <ButtonLink uri="/contact-us">Get a Quote</ButtonLink>
              </div>
            </div>
          </div>
        </div>

        <section>
          <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8">
            <div className="lg:grid lg:grid-cols-2 lg:gap-zf8 lg:items-center">
              <div className="lg:col-span-1">
                <h2 className="text-4xl tracking-tight font-extralight">
                  <span className="block text-blue-dark">
                    Tech-forward. People first.
                  </span>
                  <span className="block text-blue">The Evry Difference.</span>
                </h2>
                <p className="max-w-lg mt-6 text-lg text-grey sm:max-w-3xl">
                  We've developed one of the best tech stack in the industry. We
                  automated everything possible to improve responsiveness and
                  efficiency. We directly contracted our own medical network of
                  great local doctors. And we encourage digital medicine and
                  virtual care. Less overhead = more savings for everyone, and
                  better coverage.
                </p>
              </div>
              <div className="lg:col-span-1">
                <div className="flex items-center justify-center h-full">
                  <figure className={`${classes.sectionImageRight}`}>
                    <img
                      className="object-cover w-full h-full mt-4 md:mt-0"
                      src="friends-looking-at-sunset.png"
                      alt="friends looking at sunset"
                    />
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          {/* table with comparing two companies */}
          <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8">
            <section>
              <div className="py-16">
                <CompareTable />
              </div>
            </section>

            <section>
              <ContactForm />
            </section>
          </div>
        </section>
      </Layout>
    </>
  )
}

export default HowWeCompare
